<template>
  <BaseModal
    id="create-customer-infoauto"
    :value="true"
    :clickOutsideClose="false"
    @input="$emit('close')"
  >
    <div class="body p-10 pt-0">
      <h1>{{ $t("message.edit_infoauto_customer_modal.title") }}</h1>
      <form class="flex flex-col pt-1" @submit.prevent="updateCustomer">
        <div class="grid grid-cols-2 gap-2">
          <div class="input-item">
            <label for="modalidad-venta">{{
              $t("message.edit_infoauto_customer_modal.modalidad_venta")
            }}</label>
            <select
              type="modalidad-venta"
              class="regular bordered full"
              id="modalidad-venta"
              v-model="newCustomer.modalidadVtaId"
              required
            >
              <option
                :value="modalidadVenta.modalidadVtaId"
                :key="modalidadVenta.modalidadVtaId"
                v-for="modalidadVenta of modalidadesVenta"
                >{{ modalidadVenta?.codigo || "" }}</option
              >
            </select>
          </div>
          <div class="input-item">
            <label for="company">{{
              $t("message.edit_infoauto_customer_modal.type_of_customer")
            }}</label>
            <select
              type="company"
              class="regular bordered full"
              id="company"
              v-model="newCustomer.type"
              required
            >
              <option value="single">{{
                $t("message.edit_infoauto_customer_modal.individual")
              }}</option>
              <option value="company">{{
                $t("message.edit_infoauto_customer_modal.company")
              }}</option>
            </select>
          </div>
        </div>
        <hr class="my-2" v-if="newCustomer.type !== ''" />
        <div class="grid grid-cols-1 gap-2">
          <div v-if="newCustomer.type !== ''">
            <div class="input-item">
              <label for="name">{{
                $t("message.edit_infoauto_customer_modal.name")
              }}</label>
              <input
                type="text"
                class="regular bordered full"
                id="name"
                v-model="newCustomer.name"
                required
              />
            </div>
            <div class="input-item" v-if="newCustomer.type === 'single'">
              <label for="surname">{{
                $t("message.edit_infoauto_customer_modal.surname")
              }}</label>
              <input
                type="text"
                class="regular bordered full"
                id="surname"
                v-model="newCustomer.surname"
                required
              />
            </div>
            <div class="input-item">
              <label for="email">{{
                $t("message.edit_infoauto_customer_modal.email")
              }}</label>
              <input
                type="email"
                class="regular bordered full"
                id="email"
                v-model="newCustomer.email"
                required
              />
            </div>
            <div class="input-item">
              <label for="email2">{{
                $t("message.edit_infoauto_customer_modal.email2")
              }}</label>
              <input
                type="email"
                class="regular bordered full"
                id="email2"
                v-model="newCustomer.email2"
              />
            </div>
            <div class="input-item">
              <label for="phone">{{
                $t("message.edit_infoauto_customer_modal.rif_cedula")
              }}</label>
              <input
                type="phone"
                class="regular bordered full"
                id="phone"
                v-model="newCustomer.cedulaRif"
                required
              />
            </div>
            <template v-if="isCostaRicaStore">
              <div class="input-item">
                <label for="document-type">{{
                  $t("message.edit_infoauto_customer_modal.document_type")
                }}</label>
                <select
                  class="regular bordered full"
                  id="document-type"
                  v-model="newCustomer.tipoDocumento"
                >
                  <option value="">{{
                    $t(
                      "message.edit_infoauto_customer_modal.select_document_type"
                    )
                  }}</option>
                  <option
                    v-for="documentType in documentTypes"
                    :key="documentType.value"
                    :value="documentType.value"
                    >{{ documentType.label }}</option
                  >
                </select>
              </div>
              <div class="input-item">
                <label for="activity-code">{{
                  $t("message.edit_infoauto_customer_modal.activity_code")
                }}</label>
                <input
                  type="text"
                  class="regular bordered full"
                  id="activity-code"
                  v-model.trim="newCustomer.codActividad"
                />
              </div>
            </template>
            <div class="input-item">
              <label for="sellerId">{{
                $t("message.edit_infoauto_customer_modal.seller")
              }}</label>
              <select
                required
                v-model="newCustomer.seller"
                :disabled="
                  !$store.getters['auth/userHasPermission'](
                    'can_edit_infoauto_customer_seller'
                  )
                "
                name="sellerId"
                class="regular full bordered"
              >
                <option value="">{{
                  $t("message.edit_infoauto_customer_modal.select_seller")
                }}</option>
                <option
                  v-for="seller in sellers"
                  :key="seller.id"
                  :value="seller.id"
                  >{{ seller.name }}
                </option>
              </select>
            </div>
            <div class="input-item">
              <label for="grupo-precio">{{
                $t("message.edit_infoauto_customer_modal.price_level")
              }}</label>
              <select
                required
                v-model="newCustomer.priceLevelId"
                :disabled="
                  !$store.getters['auth/userHasPermission'](
                    'can_edit_infoauto_customer_price_level'
                  )
                "
                name="grupo-precio"
                class="regular full bordered"
              >
                <option value="">{{
                  $t("message.edit_infoauto_customer_modal.select_price_level")
                }}</option>
                <option
                  v-for="level in priceLevels"
                  :key="level.value"
                  :value="level.grupoPrecioId"
                  >{{ level.descripcion }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <hr class="my-4" />
        <div
          class="input-item flex justify-center items-center mt-4 flex flex-col"
        >
          <div
            v-if="errors"
            class="p-6 bg-red-400 w-full rounded-md text-center text-white mb-4"
          >
            {{ errors }}
          </div>
          <button
            type="submit"
            class="btn-success-button w-40 flex flex-row justify-center"
          >
            <template v-if="!loading">
              {{ $t("message.edit_infoauto_customer_modal.update") }}
            </template>
            <BaseMiniSpinner v-else />
          </button>
        </div>
      </form>
    </div>
  </BaseModal>
</template>
<script>
import { infoautoUpdateCustomer } from "@/api/store/Infoauto.js";
import { DOCUMENT_TYPES } from "@/constants/infoautoPersona";
const states = require("@/constants/states.json");

export default {
  name: "InfoautoEditCustomerModal",
  props: {
    customer: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      newCustomer: {
        name: "",
        surname: "",
        email: "",
        phone: "",
        postalCode: "",
        type: "",
        grupoPrecioId: "",
        modalidadVtaId: "",
        seller: "",
        tipoDocumento: "",
        codActividad: ""
      },
      documentTypes: DOCUMENT_TYPES,
      loading: false,
      errors: null
    };
  },
  computed: {
    isCostaRicaStore() {
      const activeStore = this.$store.getters["general/getActiveStore"];
      return activeStore?.code === "nkr_costa_rica";
    },
    modalidadesVenta() {
      return this.$store.getters["general/getModalidadesVenta"];
    },
    sellers() {
      return this.$store.getters["general/getSellers"];
    },
    priceLevels() {
      return this.$store.getters["general/getPriceLevels"];
    },
    statesFixed() {
      const keys = Object.keys(states);
      return keys.map(key => {
        return {
          shortCode: key,
          label: states[key]
        };
      });
    }
    // ,can_edit_infoauto_customer_seller,can_edit_infoauto_customer_price_level
  },
  mounted() {
    this.newCustomer = {
      name: this.customer.generalInfo.name,
      surname: this.customer.generalInfo.surname,
      email: this.customer.generalInfo.email,
      email2: this.customer.generalInfo.email2,
      type: this.customer.generalInfo.is_person === 1 ? "single" : "company",
      seller: this.customer.generalInfo.vendedorId,
      priceLevelId: this.customer.generalInfo.priceLevelId,
      modalidadVtaId: this.customer.generalInfo.modalidadVtaId,
      cedulaRif: this.customer.generalInfo.cedulaRif,
      // Precargados desde Infoauto para que modifpersona no los deje vacíos
      tipoDocumento: this.customer.generalInfo.tipoDocumento || "",
      codActividad: this.customer.generalInfo.codActividad || ""
    };
  },
  methods: {
    updateCustomer() {
      this.errors = null;
      this.loading = true;
      infoautoUpdateCustomer(
        this.customer.generalInfo.infoautoId,
        this.newCustomer
      )
        .then(res => {
          this.$emit("customerUpdated", res.customer.personaId);
          this.$toast.open({
            message: `${res.message}`,
            type: "success",
            position: "top-center"
          });
          this.$emit("close");
        })
        .catch(err => {
          this.errors = `${err.response?.data || "error"}`;
          this.$toast.open({
            message: `${err.response?.data || "error"}`,
            type: "error",
            position: "top-center"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="postcss">
#create-customer-infoauto .modal-content {
  max-width: 600px;
  height: auto;
}
</style>
